import * as z$1 from "zod/v4";
//#region src/schemas/runtime/openconnector-runtime.ts
const nonEmptyStringSchema = z$1.string().trim().min(1);
const jsonSchemaObjectSchema = z$1.record(z$1.string(), z$1.unknown());
const OPENCONNECTOR_RUNTIME_ACTION_CONTRACT_VERSION = 1;
const openConnectorRuntimeActionEffectSchema = z$1.enum([
	"destructive",
	"read",
	"write"
]);
const openConnectorRuntimeActionExecutionSchema = z$1.strictObject({
	catalogOnly: z$1.boolean(),
	locallyExecutable: z$1.boolean(),
	needsCredential: z$1.boolean(),
	noAuthRunnable: z$1.boolean(),
	requiredAuthTypes: z$1.array(z$1.enum([
		"no_auth",
		"api_key",
		"custom_credential",
		"oauth2"
	]))
}).superRefine((execution, context) => {
	if (execution.catalogOnly === execution.locallyExecutable) context.addIssue({
		code: "custom",
		message: "OpenConnector action execution must be either locally executable or catalog-only.",
		path: ["locallyExecutable"]
	});
	if (execution.needsCredential === execution.noAuthRunnable) context.addIssue({
		code: "custom",
		message: "OpenConnector action credential requirements are inconsistent.",
		path: ["needsCredential"]
	});
});
const openConnectorRuntimeActionSchema = z$1.strictObject({
	asyncLifecycle: z$1.strictObject({
		cancelActionId: nonEmptyStringSchema.optional(),
		startActionId: nonEmptyStringSchema,
		statusActionId: nonEmptyStringSchema
	}).nullable(),
	description: nonEmptyStringSchema,
	effect: openConnectorRuntimeActionEffectSchema.optional(),
	execution: openConnectorRuntimeActionExecutionSchema,
	followUpActions: z$1.array(z$1.strictObject({ actionId: nonEmptyStringSchema })),
	id: nonEmptyStringSchema,
	inputSchema: jsonSchemaObjectSchema,
	name: nonEmptyStringSchema,
	outputSchema: jsonSchemaObjectSchema,
	providerPermissions: z$1.array(nonEmptyStringSchema),
	requiredScopes: z$1.array(nonEmptyStringSchema),
	service: nonEmptyStringSchema
});
const openConnectorRuntimeActionListSchema = z$1.array(openConnectorRuntimeActionSchema);
const openConnectorRuntimeActionSearchResultSchema = z$1.strictObject({
	authenticated: z$1.boolean(),
	description: nonEmptyStringSchema,
	effect: openConnectorRuntimeActionEffectSchema.optional(),
	id: nonEmptyStringSchema,
	inputSchema: jsonSchemaObjectSchema,
	name: nonEmptyStringSchema,
	outputSchema: jsonSchemaObjectSchema,
	service: nonEmptyStringSchema
});
const openConnectorRuntimeActionSearchResultListSchema = z$1.array(openConnectorRuntimeActionSearchResultSchema);
const openConnectorRuntimeActionOperationMetaSchema = z$1.strictObject({
	actionId: nonEmptyStringSchema,
	auditPersisted: z$1.boolean(),
	executionId: nonEmptyStringSchema
});
const openConnectorRuntimeActionSuccessEnvelopeSchema = z$1.strictObject({
	data: z$1.unknown(),
	message: z$1.literal("OK"),
	meta: openConnectorRuntimeActionOperationMetaSchema,
	outputSchema: jsonSchemaObjectSchema,
	success: z$1.literal(true)
});
//#endregion
export { OPENCONNECTOR_RUNTIME_ACTION_CONTRACT_VERSION, openConnectorRuntimeActionEffectSchema, openConnectorRuntimeActionExecutionSchema, openConnectorRuntimeActionListSchema, openConnectorRuntimeActionOperationMetaSchema, openConnectorRuntimeActionSchema, openConnectorRuntimeActionSearchResultListSchema, openConnectorRuntimeActionSearchResultSchema, openConnectorRuntimeActionSuccessEnvelopeSchema };

//# sourceMappingURL=openconnector-runtime.js.map